/* Rouse page script. Runs only on the vf-rouse template. */
(function () {
  'use strict';
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var cfgEl = document.getElementById('ro-config');
  var CFG = cfgEl ? JSON.parse(cfgEl.textContent) : null;
  var money = function (cents) { var v = (cents / 100).toFixed(2); return '$' + v.replace(/\B(?=(\d{3})+(?!\d))/g, ','); };

  /* ---------- offer state ---------- */
  var state = { set: CFG ? CFG.defaultSet : '', colors: [], active: 0, addons: {} };
  function setInfo(v) { if (!CFG) return null; for (var i = 0; i < CFG.sets.length; i++) if (CFG.sets[i].value === v) return CFG.sets[i]; return CFG.sets[0]; }
  function variant(set) {
    set = set || state.set;
    for (var i = 0; i < CFG.variants.length; i++) if (CFG.variants[i].s === set) return CFG.variants[i];
    return CFG.variants[0];
  }
  function bands() { var si = setInfo(state.set); return si ? si.bands : 1; }
  function syncColors() {
    var n = bands();
    while (state.colors.length < n) state.colors.push(state.colors[state.colors.length - 1] || CFG.defaultColor);
    if (state.colors.length > n) state.colors.length = n;
    if (state.active >= n) state.active = n - 1;
  }
  function hexOf(name) { var b = $('[data-ro-swatch="' + (name || '').replace(/"/g, '') + '"]'); return b ? b.dataset.roHex : '#1d1d1f'; }
  function total() {
    var t = variant().price;
    CFG.addons.forEach(function (a) { if (state.addons[a.id]) t += a.price; });
    return t;
  }
  function renderColors() {
    if (!CFG || !CFG.defaultColor) return;
    syncColors();
    var n = bands(), slots = $('[data-ro-slots]'), label = $('[data-ro-color-label]'), hint = $('[data-ro-slot-hint]');
    var cur = state.colors[state.active];
    $$('[data-ro-swatch]').forEach(function (b) { var on = b.dataset.roSwatch === cur; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on ? 'true' : 'false'); });
    var labelRow = label ? label.parentNode : null;
    if (labelRow) labelRow.hidden = n > 1;
    if (label) {
      label.innerHTML = '';
      label.appendChild(document.createTextNode(CFG.colorLabel + ': '));
      var bb = document.createElement('b'); bb.textContent = cur; label.appendChild(bb);
    }
    if (hint) hint.textContent = '';
    if (!slots) return;
    slots.hidden = n < 2;
    slots.innerHTML = '';
    if (n < 2) return;
    state.colors.forEach(function (c, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'ro-slot' + (i === state.active ? ' is-active' : '');
      b.style.setProperty('--sw', hexOf(c));
      b.setAttribute('aria-pressed', i === state.active ? 'true' : 'false');
      b.setAttribute('aria-label', CFG.slotWord + ' ' + (i + 1) + ': ' + c);
      b.title = c;
      var dot = document.createElement('i'); b.appendChild(dot);
      b.appendChild(document.createTextNode(CFG.slotWord + ' ' + (i + 1)));
      b.addEventListener('click', function () { state.active = i; renderColors(); });
      slots.appendChild(b);
    });
    if (CFG.slotHint) {
      var h = document.createElement('small'); h.className = 'ro-slots__hint'; h.textContent = CFG.slotHint;
      slots.appendChild(h);
      var f = slots.firstChild;
      if (h.offsetTop >= f.offsetTop + f.offsetHeight) h.hidden = true;
    }
  }
  function render() {
    if (!CFG) return;
    var v = variant();
    var offer = $('#ro-offer');
    if (offer) offer.classList.toggle('is-single', state.set === CFG.singleSet);
    $$('[data-ro-set]').forEach(function (b) {
      var on = b.dataset.roSet === state.set;
      b.classList.toggle('is-selected', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
    });
    var now = $('[data-ro-price]'); if (now) now.textContent = money(v.price);
    var was = $('[data-ro-was]'), save = $('[data-ro-save]');
    if (v.compare && v.compare > v.price) {
      if (was) { was.hidden = false; was.textContent = money(v.compare); }
      if (save) { save.hidden = false; save.textContent = CFG.saveWord + ' ' + money(v.compare - v.price); }
    } else { if (was) was.hidden = true; if (save) save.hidden = true; }
    $$('.ro-addon').forEach(function (b) { b.setAttribute('aria-pressed', state.addons[b.dataset.addon] ? 'true' : 'false'); });
    $$('[data-ro-total]').forEach(function (el) { el.textContent = money(total()); });
    $$('[data-ro-sticky-name]').forEach(function (el) { var si = setInfo(state.set); el.textContent = (el.dataset.base || '') + (si ? ' · ' + si.short : ''); });
    var vi = $('input[name="id"][data-ro-variant-input]'); if (vi) vi.value = v.id;
    renderColors();
  }
  function scrollToOffer() {
    var box = document.getElementById('ro-offer');
    if (box) box.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'center' });
  }
  if (CFG) {
    $$('[data-ro-sticky-name]').forEach(function (el) { el.dataset.base = el.textContent; });
    state.colors = [CFG.defaultColor];
    $$('[data-ro-set]').forEach(function (b) { b.addEventListener('click', function () { state.set = b.dataset.roSet; render(); }); });
    $$('[data-ro-select-set]').forEach(function (b) {
      b.addEventListener('click', function () { state.set = b.dataset.roSelectSet; render(); if (!b.closest('#ro-offer')) scrollToOffer(); });
    });
    $$('.ro-addon').forEach(function (b) { b.addEventListener('click', function () { state.addons[b.dataset.addon] = !state.addons[b.dataset.addon]; render(); }); });
    $$('[data-ro-swatch]').forEach(function (b) {
      b.addEventListener('click', function () {
        syncColors();
        state.colors[state.active] = b.dataset.roSwatch;
        if (bands() > 1 && state.active < bands() - 1) state.active++;
        renderColors();
      });
    });
  }

  /* ---------- cart ---------- */
  function drawer() { return document.querySelector('cart-drawer'); }
  function sectionIds() { var d = drawer(); return d && d.getSectionsToRender ? d.getSectionsToRender().map(function (s) { return s.id; }) : []; }
  function setCount(n) { $$('[data-ro-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; }); }
  function fetchCart() { return fetch(CFG.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function post(path, body) {
    return fetch(CFG.routes.root + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.text().then(function (t) { var j; try { j = JSON.parse(t); } catch (e) { throw new Error(CFG.strings.error); } if (!r.ok || j.status) throw new Error(j.description || j.message || CFG.strings.error); return j; }); });
  }
  function paintDrawer(j, open, btn) {
    var d = drawer();
    if (!d || typeof d.renderContents !== 'function') { if (open) window.location.href = CFG.routes.cart; return; }
    if (j && j.sections) d.renderContents(j);
    if (typeof j.item_count === 'number') d.classList.toggle('is-empty', j.item_count === 0);
    if (open && typeof d.open === 'function' && !d.classList.contains('active')) d.open(btn);
  }
  function vipFirst() {
    var sheet = document.querySelector('.vf-root'), bag = drawer();
    if (!sheet || !bag || sheet.classList.contains('open')) return;
    var hide = { visibility: 'hidden', opacity: '0', 'pointer-events': 'none', transition: 'none' };
    Object.keys(hide).forEach(function (k) { bag.style.setProperty(k, hide[k], 'important'); });
    var ticks = 0, tm = setInterval(function () {
      if (sheet.classList.contains('open') || ++ticks >= 15) { clearInterval(tm); Object.keys(hide).forEach(function (k) { bag.style.removeProperty(k); }); }
    }, 100);
  }
  /* the free gift follows the band: one gift and the gift code while a band is in the cart, none without it */
  var syncing = null;
  function syncGifts() {
    if (!CFG) return Promise.resolve(null);
    if (syncing) return syncing;
    syncing = fetchCart().then(function (cart) {
      var hasMain = cart.items.some(function (i) { return i.product_id === CFG.productId; });
      var code = (CFG.giftCode || '').toUpperCase();
      var codes = (cart.discount_codes || []).map(function (c) { return c.code; });
      var others = codes.filter(function (c) { return c.toUpperCase() !== code; });
      var hasCode = codes.length !== others.length;
      var updates = {}, change = false;
      if (hasMain) {
        CFG.gifts.forEach(function (g) {
          var lines = cart.items.filter(function (i) { return i.variant_id === g.id; });
          if (!lines.length) { updates[g.id] = 1; change = true; }
          lines.forEach(function (l, k) { var want = k === 0 ? 1 : 0; if (l.quantity !== want) { updates[l.key] = want; change = true; } });
        });
      } else {
        var giftIds = CFG.gifts.map(function (g) { return g.id; });
        cart.items.forEach(function (i) { if (giftIds.indexOf(i.variant_id) > -1 || (i.properties && i.properties._gift === 'rouse')) { updates[i.key] = 0; change = true; } });
      }
      var wantCode = hasMain && code;
      if (!change && (wantCode ? hasCode : !hasCode)) { setCount(cart.item_count); return cart; }
      var body = { updates: updates, sections: sectionIds(), sections_url: window.location.pathname };
      body.discount = others.concat(wantCode ? [CFG.giftCode] : []).join(',');
      return post('cart/update.js', body).then(function (j) { paintDrawer(j, false); setCount(j.item_count); return j; });
    }).catch(function () { return null; }).then(function (c) { syncing = null; return c; });
    return syncing;
  }
  function cartItems(inCart) {
    syncColors();
    var v = variant(), props = {};
    if (CFG.defaultColor) props[CFG.colorProperty] = state.colors.join(', ');
    var items = [{ id: v.id, quantity: 1, properties: props }];
    CFG.addons.forEach(function (a) { if (state.addons[a.id]) items.push({ id: a.id, quantity: 1 }); });
    CFG.gifts.forEach(function (g) { if (!inCart[g.id]) items.push({ id: g.id, quantity: 1, properties: { _gift: 'rouse' } }); });
    return items;
  }
  function buzz(el) {
    if (reduced || !el) return;
    el.classList.remove('is-buzz'); void el.offsetWidth; el.classList.add('is-buzz');
    setTimeout(function () { el.classList.remove('is-buzz'); }, 1400);
  }
  function addToCart(btn) {
    var errs = $$('[data-ro-error]');
    errs.forEach(function (e) { e.hidden = true; });
    var buttons = $$('[data-ro-add]');
    if (buttons.some(function (b) { return b.classList.contains('is-loading'); })) return Promise.resolve();
    buttons.forEach(function (b) { b.classList.add('is-loading'); b.setAttribute('aria-busy', 'true'); });
    return fetchCart().then(function (cart) {
      var inCart = {};
      cart.items.forEach(function (i) { inCart[i.variant_id] = (inCart[i.variant_id] || 0) + i.quantity; });
      var d = drawer();
      if (d && d.setActiveElement) d.setActiveElement(btn);
      return fetch(CFG.routes.add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: cartItems(inCart), sections: sectionIds(), sections_url: window.location.pathname })
      }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); });
    }).then(function (res) {
      if (!res.ok || res.body.status) throw new Error(res.body.description || res.body.message || CFG.strings.error);
      vipFirst();
      paintDrawer(res.body, false);
      return syncGifts().then(function (c) {
        return (c && typeof c.item_count === 'number' ? Promise.resolve(c) : fetchCart()).then(function (cc) {
          setCount(cc.item_count);
          paintDrawer({ item_count: cc.item_count }, true, btn);
        });
      });
    }).catch(function (e) {
      var msg = (e && e.message) ? e.message : CFG.strings.error;
      var near = btn && btn.parentNode ? btn.parentNode.querySelector('[data-ro-error]') : null;
      (near ? [near] : errs).forEach(function (el) { el.textContent = msg; el.hidden = false; });
      if (btn && !btn.closest('#ro-offer') && !near) scrollToOffer();
    }).then(function () {
      buttons.forEach(function (b) { b.classList.remove('is-loading'); b.removeAttribute('aria-busy'); });
    });
  }
  if (CFG) {
    $$('[data-ro-add]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); buzz(b.classList.contains('ro-atc') ? b : null); addToCart(b); });
    });
    $$('[data-ro-open-cart]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        var d = drawer();
        if (!d || typeof d.open !== 'function') return;
        e.preventDefault();
        if (!d.classList.contains('active')) d.open(b);
        Promise.all([fetch(CFG.routes.root + '?sections=' + sectionIds().join(',')).then(function (r) { return r.json(); }), fetchCart()]).then(function (res) {
          d.renderContents({ id: 0, sections: res[0] });
          paintDrawer({ item_count: res[1].item_count }, true, b);
        }).catch(function () {});
      });
    });
    syncGifts();
    if (typeof window.subscribe === 'function' && window.PUB_SUB_EVENTS) {
      window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, function () { clearTimeout(window.__roSync); window.__roSync = setTimeout(syncGifts, 300); });
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('cart-remove-button, .quantity__button')) setTimeout(syncGifts, 1400);
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('cart-drawer [name="checkout"], cart-drawer a[href$="/checkout"]');
      if (!b || b.dataset.roReady === '1') return;
      e.preventDefault(); e.stopImmediatePropagation();
      syncGifts().then(function () { var n = document.querySelector('cart-drawer [name="checkout"]') || b; n.dataset.roReady = '1'; n.click(); delete n.dataset.roReady; });
    }, true);
  }
  /* the shared proof row puts a comma between the two names; this page joins them with a space */
  $$('.ro-buy__proofrow .ceyla-rproof__text').forEach(function (p) {
    Array.prototype.forEach.call(p.childNodes, function (n) { if (n.nodeType === 3 && n.textContent.trim() === ',') n.textContent = ' '; });
  });

  /* ---------- gallery ---------- */
  var track = $('.ro-gallery__track');
  var slides = track ? $$('.ro-gallery__slide', track) : [];
  var thumbs = $$('.ro-thumb');
  var current = 0;
  function go(i, smooth) {
    if (!track || !slides.length) return;
    i = Math.max(0, Math.min(slides.length - 1, i));
    track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth && !reduced ? 'smooth' : 'auto' });
  }
  function mark(i) {
    current = i;
    thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    var t = thumbs[i];
    if (t && t.parentNode) { var p = t.parentNode; p.scrollTo({ left: t.offsetLeft - p.clientWidth / 2 + t.clientWidth / 2, behavior: reduced ? 'auto' : 'smooth' }); }
    slides.forEach(function (s, k) { var vv = s.querySelector('video'); if (!vv) return; if (k === i) { var pr = vv.play(); if (pr && pr.catch) pr.catch(function () {}); } else { vv.pause(); } });
  }
  if (track) {
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== current) mark(i); ticking = false; });
    }, { passive: true });
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i, true); mark(i); }); });
    var prev = $('.ro-gallery__nav--prev'), next = $('.ro-gallery__nav--next');
    if (prev) prev.addEventListener('click', function () { go(current - 1, true); });
    if (next) next.addEventListener('click', function () { go(current + 1, true); });
    mark(0);
  }

  /* ---------- shipping dates (local calendar days) ---------- */
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function addDays(d, n) { var x = new Date(d.getFullYear(), d.getMonth(), d.getDate()); x.setDate(x.getDate() + n); return x; }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function fmtRange(a, b) { return a.getMonth() === b.getMonth() ? fmt(a) + '-' + b.getDate() : fmt(a) + ' to ' + fmt(b); }
  var lastDay = '';
  function dates() {
    if (!CFG) return;
    var now = new Date(); var key = now.toDateString();
    if (key === lastDay) return; lastDay = key;
    var s = CFG.ship;
    var shipped = addDays(now, s.ship), d1 = addDays(now, s.min), d2 = addDays(now, s.max);
    $$('[data-ro-date="order"]').forEach(function (el) { el.textContent = fmt(now); });
    $$('[data-ro-date="ship"]').forEach(function (el) { el.textContent = fmt(shipped); });
    $$('[data-ro-date="deliver"]').forEach(function (el) { el.textContent = fmtRange(d1, d2); });
  }
  dates();
  document.addEventListener('visibilitychange', function () { if (!document.hidden) dates(); });
  window.addEventListener('pageshow', dates);
  setInterval(dates, 60000);

  /* ---------- dialog ---------- */
  $$('[data-ro-dialog]').forEach(function (b) {
    b.addEventListener('click', function () { var dlg = document.getElementById(b.dataset.roDialog); if (dlg && dlg.showModal) dlg.showModal(); });
  });
  $$('.ro-dialog').forEach(function (dlg) {
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    var x = dlg.querySelector('.ro-dialog__x'); if (x) x.addEventListener('click', function () { dlg.close(); });
  });

  /* ---------- sticky bar and sample pill ---------- */
  var mainAtc = $('.ro-atc'), sticky = $('.ro-sticky'), closeSec = $('.ro-close');
  if (mainAtc && sticky && 'IntersectionObserver' in window) {
    var atcVisible = true, closeVisible = false;
    var upd = function () { sticky.classList.toggle('is-on', !atcVisible && !closeVisible && mainAtc.getBoundingClientRect().top < 0); };
    new IntersectionObserver(function (en) { atcVisible = en[0].isIntersecting; upd(); }).observe(mainAtc);
    if (closeSec) new IntersectionObserver(function (en) { closeVisible = en[0].isIntersecting; upd(); }).observe(closeSec);
    window.addEventListener('scroll', function () { if (!atcVisible) upd(); }, { passive: true });
  }
  var banner = $('.ro-disclose'), pill = $('.ro-pill');
  if (banner && pill && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) { pill.classList.toggle('is-on', !en[0].isIntersecting); }).observe(banner);
  }

  /* ---------- reveals ---------- */
  var reveals = $$('.ro-reveal');
  if (!reduced && 'IntersectionObserver' in window) {
    var rio = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); rio.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { rio.observe(el); });
    setTimeout(function () { reveals.forEach(function (el) { el.classList.add('is-in'); }); }, 9000);
  } else { reveals.forEach(function (el) { el.classList.add('is-in'); }); }

  /* ---------- scroll-linked scenes ---------- */
  var vh = window.innerHeight;
  window.addEventListener('resize', function () { vh = window.innerHeight; onScroll(); });
  function clamp(x) { return x < 0 ? 0 : x > 1 ? 1 : x; }
  function enterProgress(el, start, span) { var r = el.getBoundingClientRect(); return clamp((vh * start - r.top) / (r.height * span + vh * 0.25)); }

  /* readout: words light up one by one */
  var readouts = $$('[data-ro-readout]');
  readouts.forEach(function (h) {
    var walk = function (node) {
      Array.prototype.slice.call(node.childNodes).forEach(function (n) {
        if (n.nodeType === 3) {
          var frag = document.createDocumentFragment();
          n.textContent.split(/(\s+)/).forEach(function (w) {
            if (!w) return;
            if (/^\s+$/.test(w)) { frag.appendChild(document.createTextNode(w)); return; }
            var sp = document.createElement('span'); sp.className = 'ro-rw'; sp.textContent = w; frag.appendChild(sp);
          });
          n.parentNode.replaceChild(frag, n);
        } else if (n.nodeType === 1) { walk(n); }
      });
    };
    walk(h);
    if (!reduced) h.classList.add('is-live');
  });
  var alarmBoxes = $$('[data-ro-alarms]');
  if (!reduced) alarmBoxes.forEach(function (a) { a.classList.add('is-live'); });
  var calloutStages = $$('[data-ro-callouts]');
  if (!reduced) calloutStages.forEach(function (a) { a.classList.add('is-live'); });

  /* pulse scene */
  var pulse = $('[data-ro-pulse]'), scene = pulse ? $('[data-ro-scene]', pulse) : null;
  var caps = pulse ? $$('[data-ro-cap]', pulse) : [], dots = pulse ? $$('.ro-pulse__dots i', pulse) : [], led = pulse ? $('[data-ro-led]', pulse) : null;
  var stageNow = -1;
  function setStage(k) {
    if (k === stageNow || !caps.length) return; stageNow = k;
    caps.forEach(function (c, i) { c.classList.toggle('is-on', i === k); });
    dots.forEach(function (d, i) { d.classList.toggle('is-on', i === k); });
    var c = caps[k];
    if (led && c) led.textContent = c.dataset.led;
    var bz = c && c.dataset.buzz === 'true';
    pulse.classList.toggle('is-buzz', bz && !reduced);
    pulse.style.setProperty('--led', bz ? '1' : (k === caps.length - 1 ? '.9' : '.32'));
    pulse.style.setProperty('--glow', bz ? '1' : (k === caps.length - 1 ? '.55' : '0'));
  }
  if (pulse && caps.length) setStage(0);

  var pars = $$('.ro-par');
  var sunrise = $('[data-ro-sunrise]');
  var ticking2 = false;
  function onScroll() {
    ticking2 = false;
    if (reduced) return;
    readouts.forEach(function (h) {
      var words = h._w || (h._w = $$('.ro-rw', h));
      var p = enterProgress(h, 0.9, 1.6);
      var n = Math.round(p * words.length * 1.15);
      words.forEach(function (w, i) { w.classList.toggle('is-lit', i < n); });
    });
    alarmBoxes.forEach(function (a) {
      var items = a._a || (a._a = $$('.ro-alarm', a));
      var p = enterProgress(a, 0.95, 1.2);
      var n = Math.round(p * (items.length + 1));
      items.forEach(function (it, i) { it.classList.toggle('is-lit', i < n); });
    });
    calloutStages.forEach(function (a) {
      var items = a._c || (a._c = $$('.ro-callout', a));
      var p = enterProgress(a, 0.92, 0.9);
      var n = Math.round(p * (items.length + 1));
      items.forEach(function (it, i) { it.classList.toggle('is-lit', i < n); });
    });
    if (scene && caps.length) {
      var r = scene.getBoundingClientRect();
      var p = clamp(-r.top / Math.max(1, r.height - vh));
      setStage(Math.min(caps.length - 1, Math.floor(p * caps.length * 0.999)));
    }
    pars.forEach(function (img) {
      var r = img.parentNode.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var c = (r.top + r.height / 2 - vh / 2) / vh;
      img.style.transform = 'translateY(' + (-8 + c * -10).toFixed(2) + '%)';
    });
    if (sunrise) {
      var rs = sunrise.getBoundingClientRect();
      var ps = clamp((vh - rs.top) / (rs.height * 0.8));
      sunrise.style.setProperty('--sun', ps.toFixed(3));
    }
  }
  window.addEventListener('scroll', function () { if (!ticking2) { ticking2 = true; requestAnimationFrame(onScroll); } }, { passive: true });
  if (reduced) {
    readouts.forEach(function (h) { $$('.ro-rw', h).forEach(function (w) { w.classList.add('is-lit'); }); });
    if (sunrise) sunrise.style.setProperty('--sun', '1');
  }
  onScroll();

  /* feel it: a tap buzzes the phone where supported and shakes the band */
  $$('[data-ro-feel]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (navigator.vibrate) { try { navigator.vibrate([400, 160, 400, 160, 700]); } catch (e) {} }
      if (!pulse) return;
      pulse.dataset.felt = '1';
      var k = 0; for (var i = 0; i < caps.length; i++) if (caps[i].dataset.buzz === 'true') { k = i; break; }
      var prevStage = stageNow;
      var c = caps[k];
      if (led && c) led.textContent = c.dataset.led;
      pulse.classList.add('is-buzz');
      pulse.style.setProperty('--led', '1'); pulse.style.setProperty('--glow', '1');
      b.classList.add('is-buzz');
      var stick = $('.ro-pulse__band', pulse);
      if (stick && !reduced) { var rr = stick.getBoundingClientRect(); if (rr.bottom < 0 || rr.top > vh) stick.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
      setTimeout(function () { b.classList.remove('is-buzz'); stageNow = -1; setStage(Math.max(0, prevStage)); onScroll(); }, 2200);
    });
  });

  /* ---------- who it's for carousel ---------- */
  $$('[data-ro-track]').forEach(function (tr) {
    var sec = tr.closest('section'), prevB = $('[data-ro-prev]', sec), nextB = $('[data-ro-next]', sec);
    function step(dir) { var card = tr.querySelector('.ro-card'); var w = card ? card.getBoundingClientRect().width + 16 : 320; tr.scrollBy({ left: dir * w, behavior: reduced ? 'auto' : 'smooth' }); }
    function upd() { if (prevB) prevB.disabled = tr.scrollLeft < 8; if (nextB) nextB.disabled = tr.scrollLeft + tr.clientWidth > tr.scrollWidth - 8; }
    if (prevB) prevB.addEventListener('click', function () { step(-1); });
    if (nextB) nextB.addEventListener('click', function () { step(1); });
    tr.addEventListener('scroll', upd, { passive: true }); upd();
  });

  /* ---------- wrist fit checker ---------- */
  $$('[data-ro-fit]').forEach(function (box) {
    var min = parseFloat(box.dataset.min) || 12, max = parseFloat(box.dataset.max) || 19;
    var range = $('[data-ro-fit-range]', box), val = $('[data-ro-fit-val]', box), unitEl = $('[data-ro-fit-unit]', box), out = $('[data-ro-fit-out]', box);
    var lo = $('[data-ro-fit-lo]', box), hi = $('[data-ro-fit-hi]', box);
    var unit = 'in';
    var lo0 = parseFloat(range.min), hi0 = parseFloat(range.max);
    range.style.setProperty('--a', ((min - lo0) / (hi0 - lo0) * 100) + '%');
    range.style.setProperty('--b', ((max - lo0) / (hi0 - lo0) * 100) + '%');
    function show(cm) { return unit === 'in' ? (cm / 2.54).toFixed(1) : cm.toFixed(1).replace(/\.0$/, ''); }
    function upd() {
      var cm = parseFloat(range.value);
      val.textContent = show(cm); unitEl.textContent = unit;
      lo.textContent = show(lo0) + ' ' + unit; hi.textContent = show(hi0) + ' ' + unit;
      out.innerHTML = '';
      var ok = cm >= min && cm <= max;
      out.classList.toggle('is-no', !ok);
      out.appendChild(document.createTextNode(ok ? out.dataset.yes : (cm < min ? out.dataset.small : out.dataset.big)));
      var sm = document.createElement('small');
      sm.textContent = (ok ? out.dataset.yesNote : out.dataset.noNote).replace('{min}', show(min) + ' ' + unit).replace('{max}', show(max) + ' ' + unit);
      out.appendChild(sm);
      range.setAttribute('aria-valuetext', show(cm) + ' ' + unit);
    }
    range.addEventListener('input', upd);
    $$('[data-unit]', box).forEach(function (b) {
      b.addEventListener('click', function () { unit = b.dataset.unit; $$('[data-unit]', box).forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); }); upd(); });
    });
    upd();
  });

  render();
})();
